import React from "react";
import { FaMinus, FaPlus } from 'react-icons/fa';

function Accordion({ title, subTitle, isShow, onClick }) {
    return (
        <div className="accordion-box-faq" onClick={onClick}>
            <div className="accordion-content-faq">
                <h3 className="accordion-title-faq">{title}</h3>
                <div className={isShow ? "accordion-chevron-up-faq" : "accordion-chevron-faq"}>
                    {isShow ? <FaMinus style={{  color: '#115772' }} /> : <FaPlus  style={{ color: '#115772' }}/>}
                </div>
            </div>
            {isShow && <p className="accordion-subtitle-faq">{subTitle}</p>}
        </div>
    );
}

export default Accordion;